import styled from "../../theme";

export const RangeDateDiv = styled.div`
  direction: rtl;
`;
